import './summitsbar.less'

import React from 'react'
import {LinkType, SubeventType} from 'types'
import {style} from 'util/style'
import {Column, Grid} from 'views/layout/grid'
import {SubeventLogo} from 'views/layout/subeventlogo'
import {Theme} from 'views/theme'

const styles = style('summitsbar', ['item'])

export type SummitsbarType = {
	items?: Array<SummitsItemType>
}

export type SummitsItemType = {
	logo?: SubeventType
	date?: string
	link?: LinkType
}

export const Summitsbar: React.FC<SummitsbarType> = ({items}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<div className={styles('shapes')} />
				<Theme.Container>
					<div className={styles('items')}>
						<Grid columns={1} m={2} l={4} xl={4} xxl={4}>
							{items.map((item, i) => (
								<Column key={i}>
									<SummitsbarItem {...item} />
								</Column>
							))}
						</Grid>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const SummitsbarItem: React.FC<SummitsItemType> = ({
	logo,
	date,
	link
}) => {
	return (
		<div className={styles.item().mod(logo)}>
			<div className={styles.item('content')}>
				<div className={styles.item('content-top')}>
					{logo && (
						<SubeventLogo
							url={link && link.url}
							subevent={logo}
							className={styles.item('content-logo')}
						/>
					)}
					{date && <p className={styles.item('content-date')}>{date}</p>}
				</div>
			</div>
		</div>
	)
}
